module.exports = __webpack_public_path__ + "img/Butterfly_00131.25af6032.png";